import React from "react";
import * as Icon from "react-bootstrap-icons";
import styles from "./AwesomePagination.module.css";
import NavButton from "./components/NavButton/NavButton";
import StepCircle from "./components/StepCircle/StepCircle";
import {
  AwesomePaginationProps
} from "./AwesomePagination.types"

const AwesomePagination: React.FC<AwesomePaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  className = "",
  disabled = false
}) => {
  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div className={`${styles.container} ${className}`}>
      <NavButton
        direction="prev"
        disabled={!canGoPrev || disabled}
        onClick={() => onPageChange(currentPage - 1)}
        icon={<Icon.ChevronLeft size={20} />}
      />

      <div className={styles.stepsContainer}>
        {[...Array(totalPages)].map((_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentPage;

          return (
            <React.Fragment key={stepNumber}>
              <StepCircle
                stepNumber={stepNumber}
                isActive={isActive}
                onClick={onPageChange}
                disabled={disabled}
              />
              {stepNumber < totalPages && (
                <div className={styles.connector}>
                  <div
                    className={styles.connectorProgress}
                    style={{
                      width: stepNumber < currentPage ? "100%" : "0%",
                    }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <NavButton
        direction="next"
        disabled={!canGoNext || disabled}
        onClick={() => onPageChange(currentPage + 1)}
        icon={<Icon.ChevronRight size={20} />}
      />
    </div>
  );
};

export default AwesomePagination;
